import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Icon from "shared/components/Icon";
import { ICONS } from "shared/components/Icon";
import bookFlowItemUpdate from "redux/actions/books/bookFlowItemUpdate";
import { useDispatch } from "react-redux";

import "./style.scss";

let hideTimeout = null;

const FlowItemInputSelect = ({
    onOpen,
    onBlur,
    icon,
    dark,
    chapterItems,
    itemSelectedResult,
    flowItem,
    flowItemId,
    chapterIndex,
    osbn,
    chapterId,
    childInputSelectKey
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [show, setShown] = useState(null);
    const [dontRender, setDontRender] = useState(true);
    
    const handleOpen = () => {
      
        const dotMenu = document.querySelector(`.list-movable-${chapterIndex-1}`);
        if (dotMenu) dotMenu.style.zIndex = "99998";

        if (onOpen) onOpen();
        setShown(true)
    };


    const handleFlowItemSelect = (key) => {
        if (childInputSelectKey !== undefined) {
            const updatedFlowItem = { ...flowItem };

            if (flowItem.answers) {
                updatedFlowItem.answers = flowItem.answers.map(answer => {
                    if (answer.label === childInputSelectKey.label) {
                        return {
                            ...answer,
                            result: key,
                        };
                    }
                    return answer;
                });
            }

            if (flowItem.comparisons) {
                updatedFlowItem.comparisons = flowItem.comparisons.map(comparison => {
                    if (
                        comparison.operator === childInputSelectKey.operator &&
                        String(comparison.value) === String(childInputSelectKey.value)
                    ) {
                        return {
                            ...comparison,
                            result: key,
                        };
                    }
                    return comparison;
                });
            }

            dispatch(bookFlowItemUpdate(
                osbn,
                chapterId,
                flowItemId,
                updatedFlowItem
            ));
        }
        else {
            dispatch(bookFlowItemUpdate(
                osbn,
                chapterId,
                flowItemId,
                {
                    ...flowItem,
                    result: key
                }
            ));

        }

    }
    const handleBlur = () => {
        if (onBlur) onBlur();
        const dotMenu = document.querySelector(`.list-movable-${chapterIndex-1}`);
        if (dotMenu) dotMenu.style.zIndex = "0";
        
        setShown(false)
    };

    useEffect(() => {
        hideTimeout && clearTimeout(hideTimeout);
        if (show) {
            setDontRender(false);
        } else {
            hideTimeout = setTimeout(() => {
                setDontRender(true);
            }, 0);
        }
    }, [show]);


    const menuClasses = classNames(
        "dot-menu",
        show !== null ? show ? "show" : "hide" : "",
        dontRender && "dont-render"
    );


    const dotMenuClasses = classNames("dot-menu-button", dark && "dark");

    return (
        <>
            <a
                className={dotMenuClasses}
                tabIndex="-1"
                onBlur={handleBlur}
                onClick={handleOpen}
            >
                <Icon
                    inline
                    name={icon || ICONS.LIST}
                />
            </a>

            <div className={menuClasses}>
                <div className="menu-header">
                    {t("book.selectOption.result")}
                </div>
                <hr />
                {[
                    ...Object.entries(chapterItems),
                    ["END", { label: "End of chapter", result: "END" }]
                ].map(([key, item]) => {
                    const isSelected = key === itemSelectedResult;

                    return (
                        <span
                            key={key}
                            onMouseDown={() => handleFlowItemSelect(key)}
                            className={classNames({ "bolded-select": isSelected })}
                        >
                            {item.label}
                        </span>
                    );
                })}
            </div>
        </>
    );

};

FlowItemInputSelect.propTypes = {
    icon: PropTypes.string,
    dark: PropTypes.bool
};

export default FlowItemInputSelect;